import { gql } from '@apollo/client';

export const ListTags = gql`
  mutation ListTags($searchTag: SearchTagsInput!) {
    listTags(searchTag: $searchTag) {
      docs {
        _id
        name
        type
        active
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;

export const CreateTag = gql`
  mutation CreateTag($createTagInput: CreateTagInput!) {
    createTag(createTagInput: $createTagInput) {
      _id
      name
    }
  }
`;
